var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.dictob.wait
        ? _c(
            "div",
            { staticClass: "CruisePage__ifloader" },
            [_c(_setup.Loader, { staticClass: "CruisePage__loader" })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_setup.dictob.wait && !_setup.dictob.ok
        ? _c("div", { staticClass: "search_error" }, [
            _vm._v(
              "Не удалось получить справочник: " + _vm._s(_setup.dictob.reject)
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _setup.dictob.ok
        ? _c(
            "div",
            [
              _c(_setup.SFmain, {
                staticClass: "search__SP__main",
                attrs: {
                  properties: _setup.dictob.resolve,
                  choosed: _setup.newSearch,
                  last: _setup.crsearch_last,
                  ctype: _setup.props.ctype,
                  showFind: !_setup.searchObserve,
                },
                on: { input: _setup.SFmainHandle },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.crsearch_last.is && _setup.props.pokazat
        ? [
            !_setup.isFilterStatic
              ? [
                  _c(
                    "button",
                    {
                      staticClass: "search-filter-btn-mobile",
                      on: { click: _setup.doFilterOpen },
                    },
                    [_vm._v("\n                Открыть фильтры\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    _setup.Modal,
                    {
                      attrs: {
                        title: "Фильтры",
                        "wrapper-class": "animate__animated",
                        "modal-class": "search__SP__popup",
                        "in-class": "animate__fadeInLeft hideScroll",
                        "out-class": "animate__fadeOutLeft hideScroll",
                      },
                      model: {
                        value: _setup.isFilterOpen,
                        callback: function ($$v) {
                          _setup.isFilterOpen = $$v
                        },
                        expression: "isFilterOpen",
                      },
                    },
                    [
                      _c(_setup.SFaddi, {
                        staticClass: "search__SP__filter search-filter",
                        attrs: {
                          properties: _setup.dictob.resolve,
                          choosed: _setup.newSearch,
                          last: _setup.crsearch_last,
                          ctype: _setup.props.ctype,
                        },
                        on: {
                          input: _setup.SFaddiHandle,
                          reset: _setup.SFresetHandle,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "search__SP search" }, [
              _c(
                "div",
                { staticClass: "search__aside" },
                [
                  _setup.dictob.ok && _setup.isFilterStatic
                    ? [
                        _c(_setup.SFaddi, {
                          staticClass: "search__SP__filter search-filter",
                          attrs: {
                            properties: _setup.dictob.resolve,
                            choosed: _setup.newSearch,
                            last: _setup.crsearch_last,
                            ctype: _setup.props.ctype,
                          },
                          on: {
                            input: _setup.SFaddiHandle,
                            reset: _setup.SFresetHandle,
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "search__SP__answer search__content" },
                [
                  _setup.crsearch_last.wait
                    ? [_c(_setup.Loader, { staticClass: "search__SP__loader" })]
                    : _setup.crsearch_last.isEmpty
                    ? [
                        _c("div", { staticClass: "search_answer" }, [
                          _setup.crsearch_last.ok
                            ? _c("div", { staticClass: "search__no-results" }, [
                                _c("p", { staticClass: "search__title" }, [
                                  _vm._v("Круизы по запросу не найдены"),
                                ]),
                                _vm._v(" "),
                                _vm._m(0),
                              ])
                            : _c("div", { staticClass: "search__error" }, [
                                _c("p", { staticClass: "search__title" }, [
                                  _vm._v("Поиск не удался"),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Мы уже знаем о проблеме. Попробуйте снова через 15 минут. Если вопрос срочный, позвоните нам."
                                  ),
                                ]),
                              ]),
                        ]),
                      ]
                    : [
                        _c(_setup.Naideno, {
                          key: _setup.crsearch_last.id,
                          attrs: { id: _setup.crsearch_last.id },
                        }),
                      ],
                ],
                2
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [_c("br"), _c("br"), _vm._v("Попробуйте упросить запрос")])
  },
]
render._withStripped = true

export { render, staticRenderFns }